import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/hres63u/mocker'

export default {
  getLabels () {
    if (isMock) return generator(mocker.labels())
    return instance().get(endpoint + '/hres63u/labels')
  },
  getIndex (searchParams) {
    let sendParams = {}
    sendParams = {
      p_dtest: (typeof searchParams.dteapprst !== 'undefined' ? searchParams.dteapprst : ''),
      p_dteen: (typeof searchParams.dteappren !== 'undefined' ? searchParams.dteappren : ''),
      p_staappr: (typeof searchParams.staappr !== 'undefined' ? searchParams.staappr : 'P'),
      p_codempid: (typeof searchParams.codempid !== 'undefined' ? searchParams.codempid : '')
    }
    if (isMock) return generator(mocker.index())
    return instance().get(endpoint + '/hres63u/index', { params: sendParams })
  },
  getDetail (searchParams) {
    if (isMock) return generator(mocker.detail())
    const params = searchParams.p_codempid + '/' + searchParams.p_dtereq.replace(/\//g, '') + '/' + searchParams.p_numseq
    return instance().get(endpoint + '/hres63u/detail/' + params)
  },
  postSendApprove (sendParams) {
    if (isMock) return generator(mocker.sendApprove())
    return instance().post(endpoint + '/hres63u/sendApprove', sendParams)
  }
}



// WEBPACK FOOTER //
// ./src/api/hres63u/index.js